import { Component, OnInit, OnDestroy } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { LocalData, CompleterService, CompleterData, CompleterItem } from 'ng2-completer'
import { Store } from "@ngrx/store";
import { AppState } from "@store/app-state";
import { Enquiry } from "@models/enquiry";
import { Subscription } from "rxjs/Subscription";
import { EnquiriesStore } from "@store/enquiries";
import { ConstData, ConstantsHelpers } from "@constants/helpers";
import { SCHOOLS } from "@constants/schools";
import { ENQUIRY_ACTIVE_DECREMENT_STEP, ENQUIRY_ACTIVE_INCREMENT_STEP } from "@reducers/enquiries";

@Component({
  selector: 'online-enrolment-step-three',
  templateUrl: './online-enrolment-step-three.pug',
})
export class OnlineEnrolmentStepThreeComponent implements OnInit, OnDestroy {

  public enquiry: Enquiry

  public mf: FormGroup
  public hasFormBeenSubmitted: boolean
  private mfSubscription: Subscription

  public schoolCompleter: CompleterData
  public schoolSearchStr: string

  public schools: ConstData[] = SCHOOLS

  private enquirySubscription: Subscription

  constructor(
    private store: Store<AppState>,
    private fb: FormBuilder,
    private completerService: CompleterService,
    public constantsHelpers: ConstantsHelpers,
  ) {}

  ngOnInit() {
    this.enquirySubscription =
      this.store.select("enquiriesReducer").subscribe((s: EnquiriesStore) => {
        this.enquiry    = s.activeEnquiry
      })

    this.schoolCompleter =
      this.completerService.local(this.schools, "title", "title")

    this.setupMainForm()
  }

  setupMainForm() {
    this.mf = this.fb.group({
      studentFirstName:   [this.enquiry.studentFirstName, [Validators.required]],
      studentLastName:    [this.enquiry.studentLastName, [Validators.required]],
      studentGender:      [this.enquiry.studentGender, [Validators.required]],
      studentPhone:       [this.enquiry.studentPhone, [Validators.required]],
      studentDob:         [this.enquiry.studentDob, [Validators.required]],
      parentFirstName:    [this.enquiry.parentFirstName, [Validators.required]],
      parentLastName:     [this.enquiry.parentLastName, [Validators.required]],
      parentPhone:        [this.enquiry.parentPhone, [Validators.required]],
      parentEmail:        [this.enquiry.parentEmail, [Validators.required]],
      currentGrade:       [this.enquiry.currentGrade, [Validators.required]],
      preferredContact:   [this.enquiry.preferredContact, [Validators.required]],
      school:             [this.enquiry.school, [Validators.required]],
    })

    this.mfSubscription =
      this.mf.valueChanges.subscribe((data) => {
        this.updateModel(data)
      })
  }

  clickedGenderOption(value: number) {
    this.mf.patchValue({ 'studentGender': value })
  }

  clickedGradeOption(value: number) {
    this.mf.patchValue({ 'currentGrade': value })
  }

  clickedPreferredContactOption(value: number) {
    this.mf.patchValue({ 'preferredContact': value })
  }

  submittedForm({ value, valid }: { value: any, valid: boolean }) {
    this.hasFormBeenSubmitted = true

    if (valid) {
      this.store.dispatch({ type: ENQUIRY_ACTIVE_INCREMENT_STEP })
    }
  }

  clickedPrevious() {
    this.store.dispatch({ type: ENQUIRY_ACTIVE_DECREMENT_STEP })
  }

  isGenderSelected(value: number): boolean {
    return this.mf.get(`studentGender`).value === value
  }

  isGradeSelected(value: number): boolean {
    return this.mf.get('currentGrade').value === value
  }

  isPreferredContactSelected(value: number): boolean {
    return this.mf.get('preferredContact').value === value
  }

  selectedSchool(e: CompleterItem) {
    if (e && e.originalObject) {
      this.mf.patchValue({ school: e.originalObject.value })
    }
  }

  // TODO: This should all be driven by the reactive form...
  // not by manually updating the model and saving in the parent view...
  updateModel(data: any) {
    this.enquiry.studentFirstName   = data.studentFirstName
    this.enquiry.studentLastName    = data.studentLastName
    this.enquiry.studentGender      = data.studentGender
    this.enquiry.studentPhone       = data.studentPhone
    this.enquiry.studentDob         = data.studentDob
    this.enquiry.parentFirstName    = data.parentFirstName
    this.enquiry.parentLastName     = data.parentLastName
    this.enquiry.parentPhone        = data.parentPhone
    this.enquiry.parentEmail        = data.parentEmail
    this.enquiry.currentGrade       = data.currentGrade
    this.enquiry.preferredContact   = data.preferredContact
    this.enquiry.school             = data.school
  }

  ngOnDestroy() {
    this.enquirySubscription.unsubscribe()
    this.mfSubscription.unsubscribe()
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/online-enrolment-step-three.ts